var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entrance-container"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"entrance-item",on:{"click":function($event){return _vm.clickEntrance(item)}}},[_vm._v(" "+_vm._s(_vm.entranceText(item))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }